import { CoinInfo, CoinDetailJson } from './common';
import { RewardType } from './claim';
import { WalletType2 } from './wallet';
import { PoolExtendDTO } from './pool';

export type GetAccountOneParams = {
  poolId: number;
  poolCode?: string;
  poolType?: string;
  chainCode?: string;
  walletAddress?: string;
};

type ExtraYieldDTO = {
  baseYield: CoinInfo[];
  rewardYield: CoinInfo[];
  investment: CoinInfo[];
  base: string;
  crv: string;
  rewards: string;
  baseAmount: string;
  rewardsAmount: string;
  baseYieldUsd: string;
  rewardsYieldUsd: string;
};

type LpCoinDetail = {
  chainCode: string;
  chainId: number;
  decimal: number;
  iconDayUrl: string;
  iconNightUrl: string;
  symbol: string;
  price: string;
};

export type AccountOneInfo = {
  poolId: number;
  poolName: string;
  poolCode: string;
  poolType: string;
  icon: {
    day: string;
    night: string;
  };
  chainCode: string;
  contractAddresses: {
    contractAddress: string;
  }[];
  baseCoins: string[];
  rate: string;
  depositAmount: string;
  isInitStatus: boolean;
  lpTokens: string;
  combineLpTokens: string;
  lpCoin: string;
  accumulateReward: string;
  currentReward: string;
  yesterdayYieldPkg: {
    yield: string;
    rate: string;
  };
  yieldPkg: {
    yield: string;
    rate: string;
    yieldInNative: string;
  };
  depositInUsd: string;
  stakedValue: string;
  rewardClaimable: [
    {
      contractAddress: string;
      amount: string;
      rewardStatus: RewardType;
    },
  ];
  ratio: string;
  strategyData: {
    /** 策略ID */
    strategyId: number;
    /** 策略状态（11：生效中，21：执行成功，22：执行失败） */
    strategyStatus: number;
  };
  /** 持仓积分 */
  holdingPoint: string;
  lpCoinDetail: LpCoinDetail;
  extraYieldDTO: ExtraYieldDTO;
  isShowDisclaimer: boolean;
  processingUnstakeAmount: string;
  processingUnstakeTokenAmount: string;
  claimableAmount: string;
  claimableTokenAmount: string;
  extraReward: {
    rewardAmount: number;
    rewardIcon: string;
    rewardSymbol: string;
    activityCode: string;
  };
  newPoints: LombardPointItem[];
};

export type LombardPointItem = {
  name: string;
  iconUrl: string;
  amount: string;
};

export type GetAccountOneRes = AccountOneInfo;

export type PostDisclaimerRecordParam = {
  walletAddress: string;
  chainId: number;
  isChecked: boolean;
  walletType: WalletType2;
};

// DelayUnStake必须为1,位置不能换,影响后续传参数
export enum ShowType {
  InvestInfo,
  DelayUnStake = 1,
  Unstake,
  ConfimDelayUnStake,
  ConfirmUnstake,
  Choose,
  Result,
}

export type WalletAddress = { walletAddress: string; chainId: number };

export type GetAccountSumParam = {
  walletAddresses: WalletAddress[];
};

export type GetAccountSumRes = {
  depositAmountSum: string;
  yesterdayYieldPkg: {
    yield: string;
    rate: string;
  };
  yieldPkg: {
    yield: string;
    rate: string;
  };
};

export type GetAccountAllParam = {
  walletAddresses: WalletAddress[];
};

export type AccountPoolInfo = {
  accumulateReward: string;
  chainCode: string;
  chainId: number | string;
  baseCoins: CoinInfo[];
  baseStakeCoins: CoinInfo[];
  contractAddresses: {
    contractAddress: string;
  }[];
  extraYieldDTO: ExtraYieldDTO;
  poolExtendDTO: PoolExtendDTO;
  rewardClaimable: [
    {
      contractAddress: string;
      amount: string;
      rewardStatus: RewardType;
    },
  ];
  yieldPkg: {
    yield: string;
    rate: string;
  };
  lpCoinDetail: LpCoinDetail;
  currentReward: string;
  depositAmount: string;
  depositInUsd: string;
  icon: {
    day: string;
    night: string;
  };
  lpCoin: string;
  lpTokens: string;
  poolCode: string;
  poolType: string;
  poolName: string;
  poolId: number;
  rate: string;
  processingUnstakeAmount: string;
  claimableAmount: string;
  stakeType: 'common' | 'restaking';
  poolIcons?: CoinDetailJson[];
};

export type GetAccountAllRes = AccountPoolInfo[];

export enum ContentType {
  Choose = 'choose',
  DelayUnStake = 'delayUnstake',
  Unstake = 'unstake',
}
